module.exports = __webpack_public_path__ + "static/img/cup_blue.87e5b295.png";